import { ApplicationFilterArg } from '../types/application-filter-arg'
import { CustomMetadataBuckets, LabeledBucket } from '../types/bucket'

export function mapApplicationFilters(filters: ApplicationFilterArg) {
  const {
    scores = [],
    technologies = [],
    languages = [],
    tags = [],
    servers = [],
    compliance = [],
    openVulnSeverities = [],
    quickFilter,
    filterText,
    customMetadata,
    environment = [],
    appImportances = []
  } = filters

  return {
    filterText,
    quickFilter,
    scoreLetterGrades: scores,
    filterTechs: technologies,
    filterLanguages: languages,
    filterTags: tags,
    filterServers: servers,
    filterCompliance: compliance,
    filterVulnSeverities: openVulnSeverities,
    metadataFilters: customMetadata,
    environment,
    appImportances
  }
}

export function appendApplicationFiltersToBody(
  filters: ApplicationFilterArg | undefined
) {
  if (filters) {
    const {
      filterText,
      quickFilter,
      filterTechs,
      filterLanguages,
      filterTags,
      scoreLetterGrades,
      filterServers,
      filterCompliance,
      filterVulnSeverities,
      metadataFilters,
      environment,
      appImportances
    } = mapApplicationFilters(filters)

    let body: any = {
      quickFilter: quickFilter ? quickFilter : 'ALL',
      filterTechs,
      filterLanguages,
      filterTags,
      scoreLetterGrades,
      filterServers,
      filterCompliance,
      filterVulnSeverities,
      environment,
      appImportances
    }

    if (filterText) {
      body = {
        ...body,
        filterText
      }
    }

    if (metadataFilters) {
      body = {
        ...body,
        metadataFilters
      }
    }

    return body
  }
  return {}
}

export function mapLabeledBucket({ keycode: id, label, count }): LabeledBucket {
  return {
    count,
    key: {
      id,
      label
    }
  }
}

export function mapTermBucket({ count, keycode }) {
  return {
    count,
    key: keycode
  }
}

export function mapServerBucket({ keycode: id, label: name, count }) {
  return {
    count,
    key: {
      id,
      name
    }
  }
}

export function extractBuckets(mapper) {
  return function bucketMapper(data) {
    return data.filters.map(mapper)
  }
}

interface FilterGroup {
  readonly id: string
  readonly fieldType: string
  readonly label: string
  readonly values: Array<{
    readonly value: string
    readonly count: number
    readonly subfieldValues: Array<{
      readonly fieldType: string
      readonly value: string
    }>
  }>
}

export function filterGroupsToBuckets(
  groups: FilterGroup[]
): CustomMetadataBuckets[] {
  return groups.map(({ id, fieldType, label, values }) => {
    return {
      id,
      fieldType,
      label,
      buckets: values.map(({ value, count, subfieldValues }) => {
        return {
          count,
          key: {
            id: value,
            value,
            subfieldValues
          }
        }
      })
    }
  })
}
